import Units from "../../../utils/Units";
import Time from "../axes/Time";
import Kpa from "../axes/Kpa";

let LeafSensorPressureAvg = {
    type: "line",
    label: "Leaf Pressure Avg",
    fill: false,
    lineTension: 0,
    colorPalette: 3,
    borderWidth:2,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Kpa,
    xAxis:Time
};

export default LeafSensorPressureAvg;



// WEBPACK FOOTER //
// ./src/components/chart/channels/LeafSensorPressureAvg.js